import { __rest } from "tslib";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { Menu, Banner } from '@yonderland/andes-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { useFeatureToggle } from '../../../hooks/useFeatureToggle';
import { useOAuth } from '../../../hooks/useOAuth';
import { makeGetFirstName } from '../../../redux/session/selectors/SessionSelector';
import { MobileNavigationItemContent } from './MobileNavigationItemContent';
import { MobileNavigationLoginLevel } from './MobileNavigationLoginLevel';
export const MobileNavigationAccount = (_a) => {
    var { parentLevelId, backBtnLabel, login, registration, accountMenu } = _a, menuItemProps = __rest(_a, ["parentLevelId", "backBtnLabel", "login", "registration", "accountMenu"]);
    const { t } = useTranslation([I18N_NAMESPACES.account, I18N_NAMESPACES.navigation]);
    const { mainWebShop } = useAemConfig();
    const levelId = `${parentLevelId}/Account`;
    const [isLogoutInProcess, setIsLogoutInProcess] = useState(false);
    const { authUrl, logout, isLoggedIn } = useOAuth();
    const isNewAuth = useFeatureToggle('use_new_auth_flow');
    const firstName = useSelector(makeGetFirstName());
    const isLoggedInView = isLoggedIn || isLogoutInProcess;
    const handleLogout = () => {
        setIsLogoutInProcess(true);
        logout();
    };
    const getLevel = () => (_jsx(Menu.Level, { id: levelId, backBtnLabel: backBtnLabel, testId: "mobile-navigation-account-level", children: ({ isActive }) => isLoggedInView ? (_jsxs(_Fragment, { children: [_jsx(Menu.Item, { testId: "mobile-navigation-account-title", children: _jsx(MobileNavigationItemContent, { emphasized: true, children: t(`${I18N_NAMESPACES.account}:account.account.popover`) }) }), accountMenu.items.map((item, index) => (_jsx(Menu.Item, { href: item.link, testId: `mobile-navigation-item-${index}`, children: _jsx(MobileNavigationItemContent, { children: item.label }) }, item.link))), _jsx(Menu.Item, { onClick: handleLogout, testId: "mobile-navigation-item-logout", children: _jsx(MobileNavigationItemContent, { children: t(`${I18N_NAMESPACES.account}:account.logout`) }) })] })) : (_jsx(Menu.Item, { testId: "mobile-navigation-item-registration", children: _jsx(MobileNavigationLoginLevel, { isTabActive: isActive, actionUri: login.actionUri, registrationLink: registration.link }) })) }));
    return (_jsx(Menu.Item, Object.assign({}, menuItemProps, { levelId: levelId, subLevel: getLevel(), verticalInnerSpacing: false, horizontalInnerSpacing: false, children: ({ openSubLevel }) => isLoggedInView ? (_jsx(Banner, { status: "neutral", title: t(`${I18N_NAMESPACES.navigation}:navigation.account.${mainWebShop}.loggedin.title`, { firstName }), text: t(`${I18N_NAMESPACES.navigation}:navigation.account.${mainWebShop}.loggedin.message`), ctaPrimary: {
                text: t(`${I18N_NAMESPACES.navigation}:navigation.account.${mainWebShop}.loggedin.account`),
                onClick: openSubLevel,
                theme: 'branded',
            }, ctaSecondary: {
                text: t(`${I18N_NAMESPACES.navigation}:navigation.account.${mainWebShop}.loggedin.logout`),
                onClick: logout,
            } })) : (_jsx(Banner, { status: "neutral", title: t(`${I18N_NAMESPACES.navigation}:navigation.account.${mainWebShop}.guest.title`), text: t(`${I18N_NAMESPACES.navigation}:navigation.account.${mainWebShop}.guest.message`), ctaPrimary: {
                text: t(`${I18N_NAMESPACES.navigation}:navigation.account.${mainWebShop}.guest.login`),
                onClick: () => {
                    if (isNewAuth) {
                        window.location.href = authUrl;
                    }
                    else {
                        openSubLevel();
                    }
                },
                theme: 'branded',
            }, ctaSecondary: {
                text: t(`${I18N_NAMESPACES.navigation}:navigation.account.${mainWebShop}.guest.register`),
                onClick: () => {
                    window.location.href = isNewAuth ? authUrl : registration.link;
                },
            } })) })));
};
